import clsx from "clsx";
import { Button } from "./button";

export const SwitchButton = ({
  onChange = () => {},
  value = "yes",
  options = ["yes", "no"],
  className = "gap-[0.625rem]",
}: {
  onChange?: (value: string) => void;
  initialValue?: string;
  value?: string;
  options?: string[];
  className?: string;
}) => {
  return (
    <div className={clsx("w-full h-full flex font-normal", className)}>
      <Button
        radius="normal"
        height="h-full"
        active={value === options[0]}
        title={options[0].charAt(0).toUpperCase() + options[0].slice(1)}
        onClick={() => onChange(options[0])}
        className="text-xs w-full"
      />

      <Button
        radius="normal"
        height="h-full"
        active={value === options[1]}
        title={options[1].charAt(0).toUpperCase() + options[1].slice(1)}
        onClick={() => onChange(options[1])}
        className="text-xs w-full"
      />
    </div>
  );
};
